export default __webpack_public_path__ + "static/media/london.ff0b65f2.jpg";